import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion } from "@mui/material";
import React from "react";
import YouTube from "react-youtube";
import { StyledFlex } from "../../styled/flex";
import { StyledPanel } from "../../styled/panel";

export default function TutorialPanel({ videoId, title, subtitle, id }) {
  const [expanded, setExpanded] = React.useState(false);

  const newId = `pnl${id}`;
  const opts = {
    width: "640",
  };

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Accordion expanded={expanded === newId} onChange={handleChange(newId)}>
      <StyledPanel.IconLeftAccordionSummary expandIcon={<ExpandMoreIcon />}>
        <StyledFlex.ColumnContainer>
          <StyledPanel.HeadingTypography>{title}</StyledPanel.HeadingTypography>
          <StyledPanel.SecondaryHeadingTypography>
            {subtitle}
          </StyledPanel.SecondaryHeadingTypography>
        </StyledFlex.ColumnContainer>
      </StyledPanel.IconLeftAccordionSummary>
      <StyledPanel.PanelDetailContainer>
        <YouTube videoId={videoId} opts={opts} />
      </StyledPanel.PanelDetailContainer>
    </Accordion>
  );
}
